import axios from "axios";
import Config from "../utils/Config";
import Middleware from "./Middleware";

class RestMeetingService {
  config = {
    headers: {
      Authorization: "",
      CompanyId: "",
    },
  };

  // GET
  setAccessToken(accessToken, companyId) {
    this.config.headers.Authorization = accessToken;
    this.config.headers.CompanyId = companyId;
  }

  async getMeetingsForPreviousMonth(selectedDate = null, startDate = null, endDate = null, companyId, accessToken, signal) {
    this.setAccessToken(accessToken, companyId);

    // Build query string
    let query = [];
    if (selectedDate) query.push(`date=${encodeURIComponent(selectedDate)}`);
    if (startDate) query.push(`startDate=${encodeURIComponent(startDate)}`);
    if (endDate) query.push(`endDate=${encodeURIComponent(endDate)}`);
    const queryString = query.length ? `?${query.join("&")}` : "";

    const data = await Middleware.api.get(
      Config.BACKEND_URL + `/apiVWeb/meeting/forPrevious${queryString}`,
      {
        ...this.config,
        signal,
      }
    );
    return data;
  }

  async getMeetingsForUpcomingMonth(selectedDate = null, startDate = null, endDate = null, companyId, accessToken, signal) {
    this.setAccessToken(accessToken, companyId);

    // Build query string
    let query = [];
    if (selectedDate) query.push(`date=${encodeURIComponent(selectedDate)}`);
    if (startDate) query.push(`startDate=${encodeURIComponent(startDate)}`);
    if (endDate) query.push(`endDate=${encodeURIComponent(endDate)}`);
    const queryString = query.length ? `?${query.join("&")}` : "";

    // const res = await Middleware.api.get(`/apiVWeb/meeting/forUpcoming${queryString}`, this.config);
    
    const data = await Middleware.api.get(
      Config.BACKEND_URL + `/apiVWeb/meeting/forUpcoming${queryString}`,
      {
        ...this.config,
        signal,
      }
    );
    return data;
  }

  async getMeetingsForArchive(selectedDate = null, startDate = null, endDate = null, companyId, accessToken, signal) {
    this.setAccessToken(accessToken, companyId);

    // Build query string
    let query = [];
    if (selectedDate) query.push(`date=${encodeURIComponent(selectedDate)}`);
    if (startDate) query.push(`startDate=${encodeURIComponent(startDate)}`);
    if (endDate) query.push(`endDate=${encodeURIComponent(endDate)}`);
    const queryString = query.length ? `?${query.join("&")}` : "";

    const data = await Middleware.api.get(
      Config.BACKEND_URL + `/apiVWeb/meeting/forArchive${queryString}`,
      {
        ...this.config,
        signal,
      }
    );
    return data;
  }

  // async getMeetingsForPreviousMonth(
  //   selectedDate = null,
  //   startDate = null,
  //   endDate = null,
  //   companyId,
  //   accessToken,
  //   signal
  // ) {
  //   this.setAccessToken(accessToken, companyId);

  //   // Build query string
  //   let query = [];
  //   if (selectedDate) query.push(`date=${encodeURIComponent(selectedDate)}`);
  //   if (startDate) query.push(`startDate=${encodeURIComponent(startDate)}`);
  //   if (endDate) query.push(`endDate=${encodeURIComponent(endDate)}`);
  //   const queryString = query.length ? `?${query.join("&")}` : "";

  //   const res = await Middleware.api.get(`/apiVWeb/meeting/forPrevious${queryString}`, this.config);
  //   return res;
  // }

  // async getMeetingsForUpcomingMonth(
  //   selectedDate = null,
  //   startDate = null,
  //   endDate = null,
  //   companyId,
  //   accessToken,
  //   signal
  // ) {
  //   this.setAccessToken(accessToken, companyId);

  //   // Build query string
  //   let query = [];
  //   if (selectedDate) query.push(`date=${encodeURIComponent(selectedDate)}`);
  //   if (startDate) query.push(`startDate=${encodeURIComponent(startDate)}`);
  //   if (endDate) query.push(`endDate=${encodeURIComponent(endDate)}`);
  //   const queryString = query.length ? `?${query.join("&")}` : "";

  //   const res = await Middleware.api.get(`/apiVWeb/meeting/forUpcoming${queryString}`, this.config);
  //   return res;
  // }

  // async getMeetingsForArchive(
  //   selectedDate = null,
  //   startDate = null,
  //   endDate = null,
  //   companyId,
  //   accessToken,
  //   signal
  // ) {
  //   this.setAccessToken(accessToken, companyId);

  //   // Build query string
  //   let query = [];
  //   if (selectedDate) query.push(`date=${encodeURIComponent(selectedDate)}`);
  //   if (startDate) query.push(`startDate=${encodeURIComponent(startDate)}`);
  //   if (endDate) query.push(`endDate=${encodeURIComponent(endDate)}`);
  //   const queryString = query.length ? `?${query.join("&")}` : "";

  //   const res = await Middleware.api.get(`/apiVWeb/meeting/forArchive${queryString}`, this.config);
  //   return res;
  // }

  async getSignatoriesByUserId(userId, companyId, accessToken) {
    this.setAccessToken(accessToken, companyId);

    const res = await Middleware.api.get(
      `/api/signatories/userId/${userId}`,
      this.config
    );
    return res.data;
  }

  async getMeetingListForDashboard(companyId, accessToken) {
    this.setAccessToken(accessToken, companyId);

    const res = await Middleware.api.get(
      `/apiVWeb/meeting/dashboard`,
      this.config
    );
    return res.data;
  }

  async getUpdatedPaperItemDetails(agendaID, itemId, companyId, accessToken) {
    this.setAccessToken(accessToken, companyId);

    const res = await Middleware.api.get(
      `/apiVWeb/meetingAgenda/agendaItem/${agendaID}?itemId=${itemId}`,
      this.config
    );
    return res;
  }

  // POST
  async addSignatory(formData, companyId, accessToken) {
    this.setAccessToken(accessToken, companyId);

    const res = await Middleware.api.post(
      `/api/signatories`,
      formData,
      this.config
    );
    return res.data;
  }

  async getAvailableSignatory(formData, companyId, accessToken) {
    this.setAccessToken(accessToken, companyId);

    const res = await Middleware.api.post(
      `/api/meetingCoverage/availableSignatory`,
      formData,
      this.config
    );
    return res.data;
  }

  async downloadPaperItemAttachments(
    agendaId,
    formData,
    companyId,
    accessToken
  ) {
    this.setAccessToken(accessToken, companyId);

    const res = await Middleware.api.post(
      `/api/meetingAgenda/downloadAgendaCategoryItemAttachments/${agendaId}`,
      formData,
      this.config
    );
    return res;
  }

  async downloadPaperItemSingleAttachment(
    agendaId,
    formData,
    companyId,
    accessToken
  ) {
    this.setAccessToken(accessToken, companyId);

    const res = await Middleware.api.post(
      `/api/meetingAgenda/downloadAgendaCategoryItemAttachment/${agendaId}`,
      formData,
      {
        ...this.config,
        responseType: "blob",
      }
    );
    return res;
  }

  // PATCH
  async updateParticipantRsvpById(
    participantId,
    formData,
    companyId,
    accessToken
  ) {
    this.setAccessToken(accessToken, companyId);

    const res = await Middleware.api.patch(
      `/api/meetingParticipant/rsvp/${participantId}`,
      formData,
      this.config
    );
    return res;
  }

  async updateAltSignatoryPriorityLevels(formData, companyId, accessToken) {
    this.setAccessToken(accessToken, companyId);

    const res = await Middleware.api.patch(
      `/api/signatories/levels`,
      formData,
      this.config
    );
    return res;
  }

  async cancelMeeting(meetingId, formData, companyId, accessToken) {
    this.setAccessToken(accessToken, companyId);

    const res = await Middleware.api.patch(
      `/apiVWeb/meeting/cancel/${meetingId}`,
      formData,
      this.config
    );
    return res;
  }

  async changeMeetingStatus(meetingId, formData, companyId, accessToken) {
    this.setAccessToken(accessToken, companyId);

    const res = await Middleware.api.patch(
      `/apiVWeb/meeting/status/${meetingId}`,
      formData,
      this.config
    );
    return res;
  }

  async updateAgendaVoteById(agendaID, formData, companyId, accessToken) {
    this.setAccessToken(accessToken, companyId);

    const res = await Middleware.api.patch(
      `/api/meetingAgenda/agendaItemAttachmentVote/${agendaID}`,
      formData,
      this.config
    );
    return res;
  }

  // DELETE
  async deleteAlternativeSignatory(signatoryId, companyId, accessToken) {
    this.setAccessToken(accessToken, companyId);

    const res = await Middleware.api.delete(
      `/api/signatories/${signatoryId}`,
      this.config
    );
    return res;
  }

  async deleteSingleMeeting(meetingId, formData, companyId, accessToken) {
    this.setAccessToken(accessToken, companyId);

    // Attach formData to the data field of the config object.
    const config = {
      ...this.config,
      data: formData,
    };

    // Send delete request with config containing data and headers
    const res = await Middleware.api.delete(
      `/apiVWeb/meeting/${meetingId}`,
      config
    );
    return res;
  }

  // PUT
  async updateMeeting(meetingId, companyId, accessToken, payload) {
    this.setAccessToken(accessToken, companyId);

    const res = await Middleware.api.put(
      `/apiVWeb/meeting/${meetingId}`,
      payload,
      this.config
    );
    return res;
  }

  async updateAgenda(meetingId, companyId, accessToken, payload) {
    this.setAccessToken(accessToken, companyId);

    const res = await Middleware.api.post(
      `/apiVWeb/meeting/agenda/${meetingId}`,
      payload,
      this.config
    );
    return res;
  }

  // upload paper attachment
  async uploadPaperAttachments(formData, companyId, accessToken) {
    this.setAccessToken(accessToken, companyId);

    const res = await Middleware.api.post(
      `/apiVWeb/meetingAgenda/agendaItemAttachment`,
      formData,
      this.config
    );
    return res;
  }

  // adding signature and status
  async addSignature(formData, agendaID, accessToken, companyId) {
    this.setAccessToken(accessToken, companyId);

    const res = await Middleware.api.patch(
      `/api/meetingAgenda/agendaItemAttachmentSignatureAccept/${agendaID}`,
      formData,
      this.config
    );
    return res;
  }

  // upload meeting minutes
  async uploadMeetingMinutes(formData, companyId, meetingId, accessToken) {
    this.setAccessToken(accessToken, companyId);

    const res = await Middleware.api.post(
      `/apiVWeb/meeting/minute/${meetingId}`,
      formData,
      this.config
    );
    return res;
  }

  //delete leave data
  async deleteMeetingMinutes(meetingId, formData, companyId, accessToken) {
    this.setAccessToken(accessToken, companyId);

    const config = {
      ...this.config,
      data: formData,
    };

    const res = await Middleware.api.delete(
      `/apiVWeb/meeting/minute/${meetingId}`,
      config
    );
    return res.data;
  }

  // download meeting minutes
  async downloadMeetingMinutes(formData, companyId, meetingId, accessToken) {
    this.setAccessToken(accessToken, companyId);

    const res = await Middleware.api.post(
      `/api/meeting/minuteStreams/${meetingId}`,
      formData,
      {
        ...this.config,
        responseType: "blob",
      }
    );
    return res;
  }

  async getAttachmentApprovalReport(params, companyId, accessToken) {
    this.setAccessToken(accessToken, companyId);

    // Build query string from params
    const query = new URLSearchParams();
    if (params.committeeTypeId) query.append('committeeTypeId', params.committeeTypeId);
    if (params.committeeId) query.append('committeeId', params.committeeId);
    if (params.meetingName) query.append('meetingName', params.meetingName);
    if (params.paperCategoryId) query.append('paperCategoryId', params.paperCategoryId);
    if (params.paperName) query.append('paperName', params.paperName);
    if (params.documentName) query.append('documentName', params.documentName);
    if (params.dateFrom) query.append('dateFrom', params.dateFrom);
    if (params.dateTo) query.append('dateTo', params.dateTo);
    if (params.page) query.append('page', params.page);
    if (params.size) query.append('size', params.size);

    const queryString = query.toString() ? `?${query.toString()}` : '';
    const res = await Middleware.api.get(
      `/apiVWeb/meetingAgenda/attachmentApprovalReport${queryString}`,
      this.config
    );
    return res;
  }

  async getAttachmentApprovalSummary(meetingId, originalDate, attachmentId, companyId, accessToken) {
    this.setAccessToken(accessToken, companyId);

    const query = new URLSearchParams();
    query.append('meetingId', meetingId);
    query.append('originalDate', originalDate);
    query.append('attachmentId', attachmentId);

    const queryString = query.toString() ? `?${query.toString()}` : '';
    const res = await Middleware.api.get(
      `/apiVWeb/meetingAgenda/attachmentApprovalSummary${queryString}`,
      this.config
    );
    return res;
  }

  async getActivityLogReport(params, companyId, accessToken) {
    this.setAccessToken(accessToken, companyId);

    const query = new URLSearchParams();
    if (params.type) query.append('type', params.type);
    if (params.committeeId) query.append('committeeId', params.committeeId);
    if (params.meetingName) query.append('meetingName', params.meetingName);
    if (params.paperName) query.append('paperName', params.paperName);
    if (params.documentName) query.append('documentName', params.documentName);
    if (params.dateFrom) query.append('dateFrom', params.dateFrom);
    if (params.dateTo) query.append('dateTo', params.dateTo);
    if (params.author) query.append('author', params.author);
    if (params.page) query.append('page', params.page);
    if (params.size) query.append('size', params.size);

    const queryString = query.toString() ? `?${query.toString()}` : '';
    const res = await Middleware.api.get(
      `/apiVWeb/meetingAgenda/activityLogReport${queryString}`,
      this.config
    );
    return res;
  }

  async downloadActivityLogReportExcel(params, companyId, accessToken) {
    this.setAccessToken(accessToken, companyId);

    const query = new URLSearchParams();
    if (params.type) query.append('type', params.type);
    if (params.committeeId) query.append('committeeId', params.committeeId);
    if (params.meetingName) query.append('meetingName', params.meetingName);
    if (params.paperName) query.append('paperName', params.paperName);
    if (params.documentName) query.append('documentName', params.documentName);
    if (params.dateFrom) query.append('dateFrom', params.dateFrom);
    if (params.dateTo) query.append('dateTo', params.dateTo);
    if (params.author) query.append('author', params.author);

    const queryString = query.toString() ? `?${query.toString()}` : '';
    const res = await Middleware.api.get(
      `/apiVWeb/meetingAgenda/activityLogReport/download/excel${queryString}`,
      { ...this.config, responseType: 'blob' }
    );
    return res;
  }

  async downloadActivityLogReportPdf(params, companyId, accessToken) {
    this.setAccessToken(accessToken, companyId);

    const query = new URLSearchParams();
    if (params.type) query.append('type', params.type);
    if (params.committeeId) query.append('committeeId', params.committeeId);
    if (params.meetingName) query.append('meetingName', params.meetingName);
    if (params.paperName) query.append('paperName', params.paperName);
    if (params.documentName) query.append('documentName', params.documentName);
    if (params.dateFrom) query.append('dateFrom', params.dateFrom);
    if (params.dateTo) query.append('dateTo', params.dateTo);
    if (params.author) query.append('author', params.author);

    const queryString = query.toString() ? `?${query.toString()}` : '';
    const res = await Middleware.api.get(
      `/apiVWeb/meetingAgenda/activityLogReport/download/pdf${queryString}`,
      { ...this.config, responseType: 'blob' }
    );
    return res;
  }
}

export default new RestMeetingService();
